export const iconFontAwesomeCommunicationTowerCell = (
	<i className="fa-solid fa-tower-cell"></i>
);
